import { ICategory } from "../../types/stores/wiki";

export const placeholder: string = `# New Wiki Page

## This is a sub-heading...
### And here's some other cool stuff:
  
Heres some code, \`<div></div>\`, between 2 backticks.

\`\`\`
// this is multi-line code:

function anotherExample(firstLine, lastLine) {
  if (firstLine == \'\`\`\`\' \&\& lastLine == \'\`\`\`\') {
    return multiLineCode;
  }
}
\`\`\`
  
You can also make text **bold**... whoa!
Or _italic_.
Or... wait for it... **_both!_**
And feel free to go crazy ~~crossing stuff out~~.

There's also [links](https://google.com), and
> Block Quotes!

And if you want to get really crazy, even tables:

Wild Header | Crazy Header | Another Header?
------------ | ------------- | ------------- 
Your content can | be here, and it | can be here....
And here. | Okay. | I think we get it.

- And of course there are lists.
  - Some are bulleted.
     - With different indentation levels.
        - That look like this.


1. And there are numbered lists too.
1. Use just 1s if you want! 
1. But the list goes on...
- Even if you use dashes or asterisks.
* And last but not least, let's not forget embedded images:

`;

///
//id
//title
//content
//category
//createddate
//createdby
//updateddate
//updatedby
///

export const title: string = "Title";

export const wikiSearchHistoryKeyName: string = "wikiSearchHistory";

export const wikiCategories: { none: number; flows: number; release: number } = Object.freeze({
    none: 1, // pages that are none, have a stand alone page e.g. overview
    flows: 2,
    release: 3,
});

//trying to simulate generic categories from the db, should have a table with this data.
export const wikiCategoriesArray: Array<ICategory> = [
    {
        Id: 1,
        Name: "None",
        Collapsible: false,
        IsOpen: false,
        SortOrder: 1,
    },
    {
        Id: 2,
        Name: "Flows",
        Collapsible: true,
        IsOpen: false,
        SortOrder: 2,
    },
    {
        Id: 3,
        Name: "Release",
        Collapsible: true,
        IsOpen: false,
        SortOrder: 3,
    },
];

export const wikiPageTypes: { default: number; internal: number } = Object.freeze({
    default: 1, // visible to all
    internal: 2,
});

interface roles {
    "Super Admin": Array<number>;
    "Experian Admin": Array<number>;
    "Client Admin": Array<number>;
}

export const userRolesPermissionsByTypes: roles = Object.freeze({
    "Super Admin": [wikiPageTypes.default, wikiPageTypes.internal],
    "Experian Admin": [wikiPageTypes.default, wikiPageTypes.internal],
    "Client Admin": [wikiPageTypes.default],
});

export const notFoundMarkdown: string = `## Oops... Looks like the page has been changed or deleted.
### Try looking in the page list for your page.`;
